export default __webpack_public_path__ + "static/show4-45f1a0f914bac9f954a160b0272ca247.png";